const stateMap: Record<string, string> = {
  "1": "清掃中",
  "2": "スタンバイ",
  "3": "一時停止",
  "4": "一時停止",
  "5": "充電に戻っている途中",
  "6": "充電中",
  "7": "拭き清掃中",
  "8": "モップ乾燥中",
  "9": "モップ洗浄中",
  "10": "再洗浄中",
  "11": "地図作成中",
  "12": "清潔中",
  "13": "充電完了",
  "14": "アップグレード中",
  "15": "呼び出し清掃",
  "16": "ベースステーション修復中",
  "17": "モップ取り付けに戻っている途中",
  "18": "モップ取り外しに戻っている途中",
  "19": "上下水自己診断中",
  "20": "モップ洗浄と給水",
  "21": "洗浄一時停止",
  "22": "集塵中",
  "23": "リモートコントロール清掃",
  "24": "スマート補充電中",
  "25": "二次清掃中",
  "26": "追従中",
  "27": "局部清掃",
  "28": "集塵に戻っている途中",
  "29": "タスク待機中",
  "30": "ベースステーション清掃中",
  "97": "ショートカットタスク中",
  "98": "ビデオタスク中",
  "99": "ビデオタスク一時停止",
} as const;

/**
 * Dreameロボットの state から表示用のラベルを取得する
 */
export const getDreameRobotStateLabel = (state: string) => {
  return stateMap[state] ?? "不明なステータス";
};
